import { useTranslation } from 'react-i18next'
import { PaginatedFarmsTable, useFarmColumns, useLandManagement } from '@cibo/landmanager'
import { Button, Stack, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { LayoutSection } from 'components/ImpactLayout'

export const Farms = () => {
  const { t } = useTranslation('impact/pages/LandManager/Farms')

  const { openFarmDialog } = useLandManagement()
  const { actions, name } = useFarmColumns()

  return (
    <LayoutSection>
      <Typography>{t('farms')}</Typography>

      <Stack direction="row" justifyContent="end">
        <Button onClick={() => openFarmDialog({})} variant="contained" startIcon={<AddIcon />}>
          {t('createFarm')}
        </Button>
      </Stack>

      <PaginatedFarmsTable columns={[actions, name]} />
    </LayoutSection>
  )
}
